<app-modal>
  <div class="if-modal-title">This is an example project</div>
  <div class="if-modal-content">
    <div class="if-modal-message">To make changes, copy this project to your account first.</div>
  </div>
  <div class="if-modal-actions">
    <app-button (click)="cancel()" variant="ghost">Cancel</app-button>
    <app-button (click)="copyToMyProjects()" variant="primary">Copy to my projects</app-button>
  </div>
</app-modal>
